import { getCurrentShellBasePath } from "lib/routes/current-shell-path"

export function getProjectBridgeRootPath(topLevelPath) {
    return `${getCurrentShellBasePath(topLevelPath)}/project-bridge`
}

export function getProjectBridgeDetailPath(id, topLevelPath) {
    return `${getProjectBridgeRootPath(topLevelPath)}/${encodeURIComponent(id)}`
}
